import React from 'react';

import Question from 'components/forms/questionnaires/Question';

export default class QuestionEdit extends React.Component {
  render() {
    const { onSubmitParent, entity, updateEntity, questionIndex } = this.props;

    return (
      <Question
        type="edit"
        onSubmit={() => {}}
        onSubmitParent={onSubmitParent}
        entity={entity}
        updateEntity={updateEntity}
        questionIndex={questionIndex}
      />
    );
  }
}
